import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { actionTypes } from "../../../Redux";
import {
  downloadStaffTemplate,
  getSetupDetails,
  removeStaff,
  saveSetupWizardForm,
  uploadStaff,
} from "../../../Redux/actions";
import BtmButtons from "../../Components/BtmButtons";
import ExcelContainer from "../../Components/ExcelContainer";
import SWInterface from "../../Components/Layout/SWInterface";

const SetupWizardFive = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    account,
    pfs,
    statusArr,
    races,
    religions,
    states,
    countries,
    cpid,
    func,
    empCats,
    work_weeks,
    wpt,
    education_level,
    filling,
    stateFilter,
    yesNoSource,
  } = useSelector((state) => state.authReducer.setup_wizard_details);
  const upload_staff = useSelector((state) => state.authReducer.upload_staff);

  const onFileChangeEvent = (event) => {
    if (event?.target?.files[0]) {
      const formData = new FormData();
      formData.append(
        "staff_file",
        event.target.files[0],
        event.target.files[0]?.name
      );
      dispatch(uploadStaff(formData));
      event.target.value = null;
    }
  };

  useEffect(() => {
    dispatch(getSetupDetails(4));
  }, []);

  const submitNextHandler = (isLogout = false) => {
    dispatch(
      saveSetupWizardForm("four", {
        staff_sheet_data: upload_staff?.finaldata ?? "",
      })
    );
  };

  return (
    <SWInterface step={4}>
      <div className="steps-content">
        <div className="steps-div_outer">
          <div class="staff_upload" id="step4">
            <h4 class="event-alert mb-0"> Staff Upload </h4>
            <p>
              To expedite your onboarding process onto GoGMGo, please take this
              time to bulk upload your staff information. Start by downloading
              the below .xlsx format template and follow the instructions.
              <strong>
                {" "}
                If you wish to do later, download the template and upload in
                Settings {"-->"} Labor screen once logged in.
              </strong>
            </p>
            <div class="row-fluid">
              <div class="input-group my-4">
                <a
                  onClick={() => dispatch(downloadStaffTemplate())}
                  class="btn_btnblue btn download"
                >
                  <span class="i-icon"> </span> Download Template{" "}
                </a>{" "}
              </div>
            </div>
            <div class="row-fluid pt-0">
              <div class="span12">
                <div class="dropdown-table accordion-wrap">
                  <div id="accordion" class="inv-accordion">
                    <h3 class="event-alert rowNum_1 isOpen opened-h2">
                      Staff Bulk Upload
                    </h3>
                    <div class="row_buttons">
                      <form
                        // action="/users/upload_staff"
                        method="post"
                        id="form_staff_upload"
                        enctype="multipart/form-data"
                        accept-charset="utf-8"
                      >
                        <div class="input-group shift_action ">
                          <input
                            type="file"
                            name="staff_file"
                            id="staff_file"
                            class="inputfile inputfile-2"
                            data-multiple-caption="{count} files selected"
                            onChange={onFileChangeEvent}
                          />
                          <label
                            class="btn btn_btnblue upload-icon"
                            for="staff_file"
                          >
                            {" "}
                            <span class="i-icon"> </span>{" "}
                            <span>Upload Staff</span>
                          </label>
                          <button
                            class="btn cancel"
                            type="button"
                            onClick={() => dispatch(removeStaff())}
                          >
                            Remove Staff
                          </button>
                        </div>
                      </form>{" "}
                    </div>
                    <div
                      divnum="1"
                      class="accordionDiv opened-div2 bulkStaffSec"
                    >
                      <div class="inner-space  table-responsive">
                        <div id="tranststaff">
                          <ExcelContainer
                            data={upload_staff?.finaloutput ?? []}
                            columns={[
                              {
                                type: "autocomplete",
                                title: "Payroll Frequencies",
                                width: "150",
                                source: pfs,
                                autocomplete: true,
                              },
                              {
                                type: "autocomplete",
                                title: "Status",
                                width: "100",
                                source: statusArr,
                                autocomplete: true,
                              },
                              {
                                type: "text",
                                title: "First Name",
                                width: "150",
                              },
                              {
                                type: "text",
                                title: "Last Name",
                                width: "150",
                              },
                              {
                                type: "text",
                                title: "Nick Name",
                                width: "100",
                              },
                              {
                                type: "text",
                                title: "ID#/Passport#",
                                width: "150",
                              },
                              {
                                type: "autocomplete",
                                title: "Race",
                                width: "100",
                                source: races,
                                autocomplete: true,
                              },
                              {
                                type: "autocomplete",
                                title: "Religion",
                                width: "100",
                                source: religions,
                                autocomplete: true,
                              },
                              {
                                type: "calendar",
                                title: "Date of Birth",
                                width: "100",
                                options: { format: "DD/MM/yyyy" },
                              },
                              {
                                type: "text",
                                title: "Address Line #1",
                                width: "150",
                              },
                              {
                                type: "text",
                                title: "Address Line #2",
                                width: "150",
                              },
                              { type: "text", title: "City", width: "100" },
                              {
                                type: "autocomplete",
                                title: "State",
                                width: "100",
                                source: states,
                                autocomplete: true,
                                filter: stateFilter,
                              },
                              {
                                type: "autocomplete",
                                title: "Country",
                                width: "100",
                                source: countries,
                                autocomplete: true,
                              },
                              { type: "text", title: "Zipcode", width: "100" },
                              {
                                type: "text",
                                title: "Contact Number #1",
                                width: "150",
                              },
                              {
                                type: "text",
                                title: "Contact Number #2",
                                width: "150",
                              },
                              { type: "text", title: "Email", width: "150" },
                              {
                                type: "autocomplete",
                                title: "Contact Preference",
                                width: "150",
                                source: cpid,
                                autocomplete: true,
                              },
                              {
                                type: "autocomplete",
                                title: "Function",
                                width: "150",
                                source: func,
                                autocomplete: true,
                              },
                              {
                                type: "text",
                                title: "Role Title",
                                width: "150",
                              },
                              {
                                type: "autocomplete",
                                title: "Category",
                                width: "150",
                                source: empCats,
                                autocomplete: true,
                              },
                              {
                                type: "autocomplete",
                                title: "Work Week Type",
                                width: "150",
                                source: work_weeks,
                                autocomplete: true,
                              },
                              {
                                type: "calendar",
                                title: "Start Date",
                                width: "100",
                                options: { format: "DD/MM/yyyy" },
                              },
                              {
                                type: "text",
                                title: "Account Approving Manager",
                                width: "150",
                              },
                              {
                                type: "autocomplete",
                                title: "Worker Permite Type",
                                width: "150",
                                source: wpt,
                                autocomplete: true,
                              },
                              {
                                type: "autocomplete",
                                title: "Education Level",
                                width: "150",
                                source: education_level,
                                autocomplete: true,
                              },
                              {
                                type: "text",
                                title: "Emergency Contact Name",
                                width: "200",
                              },
                              {
                                type: "text",
                                title: "Relationship",
                                width: "100",
                              },
                              {
                                type: "text",
                                title: "Emergency Contact Number",
                                width: "200",
                              },
                              {
                                type: "text",
                                title: "Contact Email",
                                width: "150",
                              },
                              {
                                type: "autocomplete",
                                title: "Filling Status",
                                width: "100",
                                source: filling,
                                autocomplete: true,
                              },
                              {
                                type: "text",
                                title: "Dependents",
                                width: "100",
                              },
                              {
                                type: "number",
                                title: "Salary",
                                width: "100",
                                mask: "$ 0.0",
                                decimal: ",",
                              },
                              {
                                type: "text",
                                title: "Bank Name",
                                width: "100",
                              },
                              { type: "text", title: "Account", width: "100" },
                              { type: "text", title: "Routing", width: "100" },
                              {
                                type: "autocomplete",
                                title: "Primary",
                                width: "100",
                                source: yesNoSource,
                              },
                              { type: "hidden" },
                            ]}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <BtmButtons submitHandler={submitNextHandler} />
          </div>
        </div>
      </div>
    </SWInterface>
  );
};
export default SetupWizardFive;
